import type { ThemeFamilyId } from '@evi/skins';

/**
 * Driver-facing display-name overrides for admin theme families.
 *
 * The registry in `@evi/skins` carries the canonical names ("EVI
 * Default", "Luce") that the admin picker shows. On driver-facing
 * surfaces — the PWA picker short-list, the full Themes page, toasts,
 * the how-to-earn sheet — we re-brand as the driver sees fit without
 * disturbing admin chrome. Admin rename is a separate future ticket.
 *
 * Leave an entry undefined to fall through to the registry name.
 */
export const DRIVER_THEME_NAME_OVERRIDES: Partial<Record<ThemeFamilyId, string>> = {
  default: 'INITIATIVE',
  // luce: undefined → "Luce" from the registry
};

/**
 * Resolve the driver-facing display name for a theme family. Skins
 * (Midnight, Sunset, ...) don't flow through here — their names come
 * from the seeded Unlock docs directly and already read as
 * driver-friendly.
 */
export function driverThemeName(id: ThemeFamilyId, registryName: string): string {
  return DRIVER_THEME_NAME_OVERRIDES[id] ?? registryName;
}
